import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { SEEDBANK_STEPS } from "@/data/academy";

export default function SeedBankFeature() {
  return (
    <section className="bg-sandstone py-28 md:py-44" data-testid="seedbank-feature">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-16">
          <Reveal className="lg:col-span-7">
            <p className="overline text-copper mb-7">Seed banks</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-tight text-rainforest">
              Build the seed bank around what Country needs.
            </h2>
          </Reveal>
          <Reveal delay={0.1} className="lg:col-span-5 flex items-end">
            <p className="text-charcoal/70 text-lg font-light leading-relaxed">
              We don't begin by selling infrastructure. A seed bank is designed from the outside in —
              starting with the on-country purpose it needs to serve.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-charcoal/10 border border-charcoal/10">
          {SEEDBANK_STEPS.map((s, i) => (
            <Reveal key={s.n} delay={(i % 3) * 0.06} className="bg-sandstone">
              <div className="p-8 md:p-10 h-full hover:bg-cream transition-colors" data-testid={`seedbank-step-${i}`}>
                <span className="font-serif text-5xl text-copper">{s.n}</span>
                <h3 className="font-serif text-2xl text-rainforest mt-4 mb-3">{s.title}</h3>
                <p className="text-charcoal/60 font-light leading-relaxed">{s.body}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-14">
          <Link to="/seed-banks" data-testid="seedbank-cta" className="inline-block bg-rainforest text-cream px-8 py-4 text-sm tracking-wide hover:bg-eucalyptus transition-colors">
            Discuss a Seed Bank
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
